export default function UIBurguerMenuIcon({ isOpen }) {
    return (
        <div className={`flex  flex-col items-center justify-center w-[20px] h-[18px] gap-1 relative`}>
            <div className={`absolute duration-500 flex w-full h-0.5  ${isOpen ? 'bg-green-600 rotate-45 bottom-[50%]' : 'bg-green-600 rotate-0 bottom-0'}`} />
            <div className={`absolute duration-300 flex h-0.5  ${isOpen ? 'bg-green-600 w-0' : 'delay-300 bg-green-600 w-full'}`} />
            <div className={`absolute duration-500 flex w-full h-0.5  ${isOpen ? 'bg-green-600 -rotate-45 bottom-[50%]' : 'bg-green-600 rotate-0 bottom-[85%]'}`} />
        </div>
    )
}
